import DiamondIcon from "@mui/icons-material/Diamond"; // ✅ Icono premium
import { Box, Typography } from "@mui/material";
import { Plan } from "../../data/models/Plan/PlanModel";

export const PlanUpgradeBanner: React.FC<{
  superiorPlan: Plan;
  onUpgrade?: () => void;
}> = ({ superiorPlan, onUpgrade }) => {
  return (
    <Box
      sx={{
        height: { xs: "auto", sm: 56 },
        background:
          "linear-gradient(90deg, rgba(80, 78, 0, 0.75) 0%, rgba(50,50,60,0.75) 100%)",
        backdropFilter: "blur(12px)",
        WebkitBackdropFilter: "blur(12px)",
        borderBottom: "1px solid rgba(255,255,255,0.12)",
        boxShadow: "0 10px 30px rgba(0,0,0,0.35)",
        position: "sticky",
        top: 0,
        zIndex: 999,
        display: "flex",
        flexDirection: { xs: "column", sm: "row" },
        alignItems: "center",
        justifyContent: "center",
        gap: { xs: 1.2, sm: 2.5 },
        py: { xs: 1.4, sm: 0 },
        px: 3,
        color: "white",
        borderRadius: "50px",
      }}
      mb={2}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
          maxWidth: { xs: "92%", sm: "none" },
          textAlign: "center",
        }}
      >
        <DiamondIcon
          sx={{
            fontSize: 22,
            color: "gold",
            textShadow: "0 0 8px rgba(255,215,0,0.7)",
          }}
        />

        <Typography
          sx={{
            fontSize: { xs: 13.5, sm: 14 },
            fontWeight: 500,
            letterSpacing: 0.3,
            lineHeight: { xs: 1.3, sm: 1.15 },
            textShadow: "0 2px 6px rgba(0,0,0,0.25)",
          }}
        >
          Sube al plan{" "}
          <Box
            component="span"
            sx={{
              fontWeight: 800,
              background: "linear-gradient(90deg, #FFD700 0%, #FFF3B0 100%)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
            }}
          >
            {superiorPlan.name}
          </Box>{" "}
          | {superiorPlan.description}
        </Typography>
      </Box>
      <Box
        onClick={onUpgrade}
        sx={{
          mt: { xs: 0.7, sm: 0 },
          px: 2.8,
          py: 0.65,
          borderRadius: "10px",
          cursor: "pointer",
          fontSize: 13,
          fontWeight: 700,
          whiteSpace: "nowrap",
          background:
            "linear-gradient(135deg, rgba(255,215,0,0.32) 0%, rgba(255,225,120,0.22) 100%)",
          border: "1px solid rgba(255,215,0,0.55)",
          backdropFilter: "blur(5px)",
          WebkitBackdropFilter: "blur(5px)",
          color: "white",
          boxShadow: "0 5px 15px rgba(255,215,0,0.25)",
          transition: "all 0.25s ease",

          "&:hover": {
            background:
              "linear-gradient(135deg, rgba(255,225,140,0.45) 0%, rgba(255,245,180,0.35) 100%)",
            transform: "translateY(-2px) scale(1.03)",
            boxShadow: "0 8px 20px rgba(255,215,0,0.4)",
          },
        }}
      >
        Mejorar a VIP →
      </Box>
    </Box>
  );
};
